// src/pages/Pohistvo.tsx
import CategoryPage from './CategoryPage';

const Pohistvo = () => {
  const subcategories = [
    {
      title: "Kolekcija Eleganca",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/pohistvo/kolekcija-eleganca"
    },
    {
      title: "Kolekcija Dobro počutje",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/pohistvo/kolekcija-dobro-pocutje"
    },
    {
      title: "Kolekcija Harmonija",
      imageSrc: "https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80",
      url: "/pohistvo/kolekcija-harmonija"
    },
    {
      title: "Kolekcija Natur",
      imageSrc: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&q=80",
      url: "/pohistvo/kolekcija-natur"
    }
  ];

  return (
    <CategoryPage
      title="Pohištvo"
      description="Raziščite našo luksuzno kolekcijo kopalniških pohištvenih kosov, ki združujejo eleganco, funkcionalnost in vrhunsko obrtno izdelavo."
      heroImage="https://images.unsplash.com/photo-1629079447777-1e605162dc8d?auto=format&fit=crop&q=80"
      subcategories={subcategories}
    />
  );
};

export default Pohistvo;